/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Cancel_Application_ConfirmInputs */

const en_candidate_cancel_application_confirm = /** @type {(inputs: Candidate_Cancel_Application_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you really want to withdraw your application?`)
};

const de_candidate_cancel_application_confirm = /** @type {(inputs: Candidate_Cancel_Application_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung wirklich zurückziehen?`)
};

/**
* | output |
* | --- |
* | "Do you really want to withdraw your application?" |
*
* @param {Candidate_Cancel_Application_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_cancel_application_confirm = /** @type {((inputs?: Candidate_Cancel_Application_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Cancel_Application_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_cancel_application_confirm(inputs)
	return en_candidate_cancel_application_confirm(inputs)
});